<a *ngIf="invoice_model" class="grid-link" [routerLink]="['/resident-invoice', invoice_model.id]">{{ invoice_model.name }}</a>
